import { FormatListBulletedOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'

import { NavbarItem } from '@collaborate-health/uikit'

const CreditsTab: React.FC = () => {
  return <NavbarItem name='Credits' href={Routes.credits} icon={<FormatListBulletedOutlined />} />
}

export default CreditsTab

